import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/memberships/membership-type/:membershipTypeId/`;
type MutationFnType = typeof mutationFn;

interface DTO {
    parkingId: string;
    membershipTypeId: string;
}
const mutationFn = ({ parkingId, membershipTypeId }: DTO): Promise<void> => {
    return axios.delete(formatResourcePath(RESOURCE, { parkingId, membershipTypeId }));
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useDeleteMembershipType };
